import React from 'react';
import {getCookie, showToast, getFetchError, getCatchError, getDecryptCookie} from '../app_common.js';

const __Common = 0;
//입력된 permission미만 접근금지
export const checkPermission = (apiName, permission, isShowToast = true) => {

    let status = -1;
    let type = getDecryptCookie('type');
    // let type = 'admin';

    if( type != null )
    {
        if( type.toLowerCase().includes('admin') )
        {
            status = 2;
        }
        else if( type.toLowerCase().includes('operator') )
        {
            status = 1;
        }
        else if( type.toLowerCase().includes('monitoring') )
        {
            status = 0;
        }
    }

    if( status < permission)
    {
        if( isShowToast )
        {
            showToast('Permission denied', 'error');
        }

        // console.log(apiName);
        return false;
    }
    else
    {
        // showToast('Permission enable', 'info');
        return true;
    }
}

export const TIMEOUT = 50000;
export const PERMISSION_ADMIN = 2;
export const PERMISSION_OPERATOR = 1;
export const PERMISSION_MONITORING = 0;
export const fetchWithTimeout = async(resource, options) => {
    const { timeout = 8000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(`${resource}`, {
    // const response = await fetch(`http://10.7.23.106:8080${resource}`, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}

export const fetchWithTimeoutEtc = async(resource, options) => {
    const { timeout = 8000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}

const __User = 0;
export const getApiUser = async() => {
    if( !checkPermission('getApiUser', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/user`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiUserSignup = async(userName, password) => {
    // if( !checkPermission('postApiUserSignup', PERMISSION_MONITORING) )
    // { 
    //     return null;
    // }

    try {
        const response = await fetchWithTimeout(`/api/user/signup`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: `username=${userName}&password=${password}`,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiUserSignin = async(urlencoded) => {
    // if( !checkPermission('postApiUserSignin', PERMISSION_MONITORING) )
    // { 
    //     return null;
    // }

    try {
        const response = await fetchWithTimeout(`/api/user/signin`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: urlencoded,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return [json, response];
        } catch (e) {
            getFetchError(response, null, false);
            return [null, response];
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiUserSignout = async(urlencoded) => {
    if( !checkPermission('postApiUserSignout', PERMISSION_MONITORING) )
    { 
        if( !checkPermission(PERMISSION_MONITORING) || !getDecryptCookie('using').toLowerCase().includes(urlencoded.get('using').toLowerCase()) )
        { 
            return null;
        }
    }

    try {
        const response = await fetchWithTimeout(`/api/user/signout`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: urlencoded,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiUserPassword = async(userName, oldPass, newPass) => {
    if( !checkPermission('putApiUserPassword', PERMISSION_MONITORING) )
    { 
        return null;
    }

    if( !getDecryptCookie('using').toLowerCase().includes(userName.toLowerCase()) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/user/password`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: `username=${userName}&password=${oldPass}&new_password=${newPass}`,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiUserPermission = async(userName, permission) => {
    if( !checkPermission('putApiUserPermission', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/user/permission`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: `username=${userName}&permission=${permission}`,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiUserDelete = async(username) => {
    if( !checkPermission('postApiUserDelete', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/user/delete`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                'Content-type': 'application/x-www-form-urlencoded',
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: `username=${username}`,
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiUserCount = async() => {
    if( !checkPermission('getApiUserCount', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/user/count`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                'accept' : 'application/json',
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

const __System = 0;
export const getApiSystemLicense = async() => {
    if( !checkPermission('getApiSystemLicense', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/license`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('refreshToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }     
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiSystemLicense = async() => {
    if( !checkPermission('putApiSystemLicense', PERMISSION_OPERATOR) )
    { 
        return null;
    }
    //아직 무슨 API인지 확인하지 못함

    try {
        const response = await fetchWithTimeout(`/api/system/license`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('refreshToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemServiceLog = async(service) => {
    if( !checkPermission('getApiSystemServiceLog', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/service/log?service=${service}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "text/plain",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }   
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemServiceRestart = async(service) => {
    if( !checkPermission('postApiSystemServiceRestart', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/service/restart?service=${service}`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemStatus = async() => {
    if( !checkPermission('getApiSystemStatus', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/status`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }      
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemStatusClear = async() => {
    if( !checkPermission('getApiSystemStatus', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/status-clear`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }      
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemLoad = async() => {
    if( !checkPermission('getApiSystemLoad', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/load`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }      
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemDbReset = async() => {
    if( !checkPermission('postApiSystemDbReset', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/db/reset`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemVersion = async() => {
    // if( !checkPermission('getApiSystemVersion', PERMISSION_MONITORING) )
    // { 
    //     return null;
    // }

    try {
        const response = await fetchWithTimeout(`/api/system/version`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemLogExport = async() => {
    if( !checkPermission('getApiSystemLogExport', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/log/export`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSystemDbDump = async() => {
    if( !checkPermission('getApiSystemDbDump', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/db/dump`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemDbRestore = async() => {
    if( !checkPermission('postApiSystemDbRestore', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/db/restore`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemDbDataClear = async(dbType) => {
    if( !checkPermission('postApiSystemDbDataClear', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/db/data-clear?data=${dbType}`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiSystemDbFactoryReset = async() => {
    if( !checkPermission('postApiSystemDbFactoryReset', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/system/db/factory-reset`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

//server와의 연결이 끊어졌다고 의심될때 확인을 위해 변형된 ping 함수
export const getPingCheckServer = async() => {
    try {
        const response = await fetchWithTimeout(`/ping`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        return 'done';
    } catch (err) {
        return err;
    };
}

export const getPing = async() => {
    // if( !checkPermission('getPing', PERMISSION_MONITORING) )
    // { 
    //     return null;
    // }

    try {
        const response = await fetchWithTimeout(`/ping`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return err;
    };
}

export const postPing = async() => {
    // if( !checkPermission('postPing', PERMISSION_MONITORING) )
    // { 
    //     return null;
    // }

    try {
        const response = await fetchWithTimeout(`/ping`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

const __Auth = 0;
export const getApiToken = async() => {
    if( !checkPermission('getApiToken', PERMISSION_ADMIN) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout("/api/token", {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiToken = async() => {

    let refreshToken = getCookie('refreshToken');
    if( !refreshToken )
    {
        return null;
    }
    
    if( !checkPermission('postApiToken', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/token/`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + refreshToken
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return [json, response];
        } catch (e) {
            getFetchError(response, null, false);
            return [null, response];
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiTokenName = async(userName) => {
    //아직 확인되지 않은 API
    if( !checkPermission('delApiTokenName', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout("/api/token/"+userName, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiTokenIssue = async(userName, permission, expires) => {
    //아직 확인되지 않은 API
    if( !checkPermission('postApiTokenIssue', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/token-issue?name=${userName}&permission=${permission}&expires=${expires}`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiTokenIssueIssuer = async(issuer) => {
    //아직 확인되지 않은 API
    if( !checkPermission('getApiTokenIssueIssuer', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/token-issue/${issuer}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

const __Changes = 0;
export const getApiChanges = async() => {
    if( !checkPermission('getApiChanges', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/changes`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

const __Mapbox = 0;
export const getApiMapboxTokenCheck = async(token) => {
    if( !checkPermission('getApiMapboxGeocoding', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeoutEtc(`https://api.mapbox.com/tokens/v2?access_token=${token}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiMapboxGeocoding = async(address, token) => {
    if( !checkPermission('getApiMapboxGeocoding', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeoutEtc(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?limit=1&access_token=${token}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiMapboxReverseGeocoding = async(latitude, longitude, token) => {
    if( !checkPermission('getApiMapboxReverseGeocoding', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeoutEtc(`https://api.mapbox.com/geocoding/v5/mapbox.places/${latitude},${longitude}.json?access_token=${token}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}